import React, { useEffect, useState } from 'react'
import Answers from './Answers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ReactQuill from 'react-quill';
import Uploader from '../../../partial/Uploader';
import PulseLoader from 'react-spinners/PulseLoader';
import getFilePath from '../../../utils/getFilePath';


function Question({question, changeAnswer, answered}) {
    const {_id} = question

    if(!question || !question._id)   return <PulseLoader color={"#FFF"} />

    const content = (
        <div className='question-pane'>
                <ReactQuill
                     theme='bubble'
                    readOnly
                    value={ question.title}
                    
                    ></ReactQuill>       
                {question.img && <img className='user-img' src={getFilePath(question.img)} />}


            <Answers answerOptions={question.answerOptions} answered={answered}  userQuestionId={_id}   changeAnswer={changeAnswer} />

            </div>    

           
          
    )
  return content
}

export default Question